import { BulkNodesEditFormNodeRowValues } from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/schema"
import { AppNode, NodeType } from "@features/builder/graph/types"
import { encodeNodeUnit } from "@utils/format/nodeUnitFormat"
import { createLagNodeLabel } from "@utils/node"
import { isTaggableNodeType } from "@features/builder/helpers/nodes"
import { flattenGraphTagsFormValues } from "@features/builder/NodeDrawer/NodeForm/helpers"

export const applyFormValuesToNode = <TNode extends AppNode>(
  row: BulkNodesEditFormNodeRowValues,
  node: TNode,
): TNode => {
  const updatedNode = structuredClone(node)

  // update label
  const label =
    updatedNode.type === NodeType.Lag
      ? createLagNodeLabel(row.label, row.lagValue ?? 1)
      : row.label ?? ""

  updatedNode.data.label = label
  if ("metaNode" in updatedNode.data) updatedNode.data.metaNode.label = label
  if ("metaGroup" in updatedNode.data) updatedNode.data.metaGroup.label = label

  if ("metaNode" in updatedNode.data) {
    // update mnemonics
    updatedNode.data.metaNode["Historic Mnem"] = row.historicMnemonic ?? ""
    updatedNode.data.metaNode["Scenario Mnem"] = row.scenarioMnemonic ?? ""
    updatedNode.data.metaNode["Forecast Mnem"] = row.forecastMnemonic ?? ""

    // update unit format
    const encodedUnit = encodeNodeUnit({
      isEmpty: row.unitDecimalPlaces === "", // decimal places is the only required field to compose unit format
      decimalPlaces: row.unitDecimalPlaces ?? "",
      usePercentageValue: row.unitShowAsPercentage,
      suffix: row.unitSuffix ?? "",
    })
    updatedNode.data.metaNode["Unit Format"] = encodedUnit

    updatedNode.data.metaNode.Link = row.link ?? ""

    if (isTaggableNodeType(updatedNode.type)) {
      updatedNode.data.metaNode.tags = (row.tags ?? []).map((tag) => ({
        Name: tag.tag,
        Value: tag.value,
      }))
      updatedNode.data.metaNode.graph_tags = flattenGraphTagsFormValues(row.graphTags ?? [])
    }
  }

  return updatedNode
}
